import { render, staticRenderFns } from "./SingleItemBundle.vue?vue&type=template&id=127e5408&"
import script from "./SingleItemBundle.vue?vue&type=script&lang=js&"
export * from "./SingleItemBundle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports